/**
 * Generate a v4 UUID with secure random bytes, including on HTTP origins where
 * crypto.randomUUID is unavailable. Never fall back to Math.random.
 */
export function generateUUID(): ReturnType<Crypto['randomUUID']> {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 9562 variant
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
